/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider, List } from "@mantine/core";

export default function UseOfDataCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Use of Your Personal Data</Title>
      <Divider my="md" />
      <Text>The Company may use Personal Data for the following purposes:</Text>

      <List spacing="xs" mt="sm">
        <List.Item>
          <strong>Provide and maintain the Service</strong>, including to
          monitor usage.
        </List.Item>
        <List.Item>
          <strong>Manage Your Account</strong> — to manage your registration as
          a user of the Service.
        </List.Item>
        <List.Item>
          <strong>For the performance of a contract</strong> — development,
          compliance and undertaking of purchase contracts.
        </List.Item>
        <List.Item>
          <strong>To contact You</strong> — by email, telephone, SMS, or push
          notifications.
        </List.Item>
        <List.Item>
          <strong>To provide You</strong> with news, special offers and general
          information, unless you opt out.
        </List.Item>
        <List.Item>
          <strong>To manage Your requests</strong> and customer support.
        </List.Item>
        <List.Item>
          <strong>For business transfers</strong> such as mergers, acquisitions,
          or sales of assets.
        </List.Item>
        <List.Item>
          <strong>For other purposes</strong> — data analysis, identifying usage
          trends, improving our services.
        </List.Item>
      </List>
    </Card>
  );
}
